var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import "./style.css";
import SubmitAction from "../../../components/submitAction/submitAction";
import Provider from "./Provider";
import GreyInfo from "../greyInfo/greyInfo";
import BooleanButton from "../button/booleanButton";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import LabeledSelect from "../labeledSelect/labeledSelect";
export default function IntProviderEditor(props) {
    const [ishiddenStorage, setHiddenStorage] = useLocalStorage("int-provider-editor-hide-types", "false");
    const hasHiddenTypes = ishiddenStorage === "false" ? false : true;
    const pricingTypes = [
        {
            label: "Cena za sztukę (domyślnie)",
            value: "price_per_item",
        },
        {
            label: "Operacje cenowe (dynamiczne ceny)",
            value: "price_operations",
        },
    ];
    const pricingIndex = typeof props.provider === "number" ? 0 : 1;
    return (React.createElement("div", { className: "price-provider-box" },
        React.createElement(SubmitAction, { onReject: () => props.onSetOpen(false), removeExtraPadding: true, onSubmit: () => __awaiter(this, void 0, void 0, function* () {
                props.onSetOpen(false);
            }), revertButtonColors: true, withoutCancelButton: true, message: React.createElement("div", { className: "price-provider-editor-box" },
                React.createElement("b", null, "Operacje cenowe:"),
                React.createElement(GreyInfo, null,
                    "Dzi\u0119ki operacjom cenowym cena mo\u017Ce by\u0107 ustalana dynamicznie na",
                    React.createElement("br", null),
                    "podstawie zam\u00F3wienia klienta"),
                React.createElement("br", null),
                React.createElement(LabeledSelect, { label: "Typ ceny", options: pricingTypes, defaultValueIndex: pricingIndex, state: pricingIndex, disableChangeEventOnFirstRender: true, onChange: (newValue) => {
                        if (newValue === "price_per_item") {
                            props.onProviderUpdate(0);
                        }
                        else {
                            props.onProviderUpdate({
                                type: "per-item",
                                value: { type: "constant", value: 10 },
                            });
                        }
                    } }),
                React.createElement(BooleanButton, { defaultState: hasHiddenTypes, label: "Schowaj typy (poprawia przejrzysto\u015B\u0107)", onClick: (newValue) => setHiddenStorage(newValue + "") }),
                React.createElement(Provider, Object.assign({}, props, { hasHiddenType: hasHiddenTypes }))) })));
}
